<template>
  <div class="margins-container">
    <delta-margins v-if="isDeltasEnabled" />
    <anchor-margins v-else />
  </div>
</template>

<script>
import featureFlagsMixin from '../../../mixins/featureFlags';
import { anchorMarginsEnableDeltas } from '@enums/feature-flags';

export default {
  mixins: [featureFlagsMixin],

  computed: {
    isDeltasEnabled() {
      return this.isFeatureFlagEnabled(anchorMarginsEnableDeltas);
    },
  },
};
</script>
